import classNames from 'classnames';
import { FC } from 'react';

import { FileName, AudioPlayerTrackCaption, PlayIconType } from '@gem/ui-kit';

import { AudioState } from 'APP/main/components/AudioState/AudioState';
import { AudioUploadState } from 'APP/main/components/AudioUploadState/AudioUploadState';

import styles from './ArticleAudioPlayer.styles.m.css';

interface IArticleAudioPlayerProps {
  className?: string;
  messageId: string;
  groupId: string;
  payloadId: string;
  isPlaying: boolean;
  isActiveTrack: boolean;
  progress: number;
  duration: number;
  fileName: string;
  size: number;
  uploadProgress: number | null;
  hasError: boolean;
  onTogglePlay(): void;
  cancelUploadAndDeleteMessage(): Promise<void>;
}

export const ArticleAudioPlayer: FC<IArticleAudioPlayerProps> = (props) => {
  const {
    className,
    messageId,
    groupId,
    payloadId,
    isPlaying,
    isActiveTrack,
    fileName,
    size,
    duration,
    progress,
    uploadProgress = null,
    hasError,
    onTogglePlay,
    cancelUploadAndDeleteMessage,
  } = props;

  return (
    <div className={classNames(styles.container, className)}>
      {uploadProgress !== null ? (
        <AudioUploadState
          className={styles.icon}
          uploadFileData={{
            uploadProgress,
            cancelUpload: cancelUploadAndDeleteMessage,
            hasError,
          }}
          iconType={isPlaying ? PlayIconType.Pause : PlayIconType.Play}
          onClick={onTogglePlay}
        />
      ) : (
        <AudioState
          className={styles.icon}
          groupId={groupId}
          messageId={messageId}
          payloadId={payloadId}
          iconType={isPlaying ? PlayIconType.Pause : PlayIconType.Play}
          onClick={onTogglePlay}
        />
      )}
      <div>
        <FileName
          className={styles.title}
          name={fileName}
        />
        <AudioPlayerTrackCaption
          isPlaying={isActiveTrack}
          duration={duration}
          progress={progress}
          size={size}
        />
      </div>
    </div>
  );
};
